import {HTTP} from "../../../libs/HTTP"
import AccountTag from "../model/AccountTag";

class TagsApi {
    uriPrefix = "/api/tags";

    getAccountTags() {
        return HTTP.get(this.uriPrefix)
            .then(response => response.data)
    }

    getAccountTag(tagId: number) {
        return HTTP.get(this.uriPrefix + `/${tagId}`)
            .then(response => response.data)
    }

    createAccountTag(accountTag: AccountTag) {
        return HTTP.post(this.uriPrefix, accountTag)
            .then(response => response.data)
    }

    updateAccountTag(accountTag: AccountTag) {
        return HTTP.put(this.uriPrefix, accountTag)
            .then(response => response.data)
    }
    deleteAccountTag(accountTag: AccountTag) {
        return HTTP.delete(this.uriPrefix + `/${accountTag.tagId}`)
            .then(response => response.data)
    }
}
const tagsApi =  new TagsApi();
export default tagsApi;